import ShopType from "@/enum/ShopType";

const PDDShop = {
    [ShopType.PINDUODUO]: {
        image: "//img.alicdn.com/imgextra/i2/54458674/O1CN01ObUANj2DwkSJVp2lk_!!54458674.png",
        auth: `/login/selectLoginMethod?shopType=${ShopType.PINDUODUO}`,
    },
    [ShopType.KTT]: {
        image: "https://img.alicdn.com/imgextra/i2/54458674/O1CN01qpSdvo2DwkNQnBukN_!!54458674.png",
        auth: `/login/selectLoginMethod?shopType=${ShopType.KTT}`,
    },
};

export default PDDShop;
